import { Component, Vue } from "vue-property-decorator";
import dateranges from "@/data/dateranges";
import { IStatRange } from "@/models/stats";
import { UserMetaKeys } from "@/data/enums/users";
import store from "@/store";

@Component
export default class StatsStorageMixin extends Vue {
  // Methods

  public trySetStatDateToStorage(statRange: IStatRange) {
    if (
      this.$_.isDate(statRange.dateFrom) &&
      this.$_.isDate(statRange.dateTo) &&
      statRange.key // Must be one of the predefined dates, custom doesn't have key
    ) {
      try {
        store.dispatch("user/addMeta", {
          [UserMetaKeys.UI_STATS_TIMEFRAME]: statRange.key
        });
      } catch {
        store.dispatch("user/removeMetaKey", UserMetaKeys.UI_STATS_TIMEFRAME);
      }
    }
  }

  /**
   * Tries to get dates from localstorage, if not fallsback to @param range
   */
  public tryGetStatDateFromStorage(range: IStatRange) {
    const key =
      store.getters["user/meta"](UserMetaKeys.UI_STATS_TIMEFRAME) || "";
    return this.$_.has(dateranges.ranges, key) ? dateranges.ranges[key] : range;
  }
}
